import { render, staticRenderFns } from "./addTeachRoomLock.vue?vue&type=template&id=65b1a869&"
import script from "./addTeachRoomLock.vue?vue&type=script&lang=js&"
export * from "./addTeachRoomLock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports